/**
 * 应用入口。
 *
 * 设计令牌的**唯一**运行时来源是 docs/design-system/design-tokens.css，通过 @tokens 别名
 * 直接引用（docs/03-UIUX.md §2）—— 应用层不复制一份，从物理上杜绝令牌漂移。
 * 因此顺序必须是：令牌变量先定义，组件样式后加载，组件才能正确读到 var(--*)。
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import '@tokens/design-tokens.css';
import './styles/app.css';
import './styles/components.css';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('找不到 #root 挂载点，index.html 结构被破坏。');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
